import React from 'react'

const Maxi = () => {
    return (
        <div>Maxi</div>
    )
}

export default Maxi